import StyledTag from "./tag.style";
import _ from 'lodash';
import {Link} from 'gatsby';
import React from 'react'

interface TagProps {
    text: string;
    isLink?: boolean;
    className?: string;
    method?: any;
}

const Tag: React.FC<TagProps> = (
    {
        text,
        isLink = true,
        className='',
        method=undefined,
    }) => {
    className += isLink || method ? ' interactive' : ''
    return (
        isLink ? (
            <Link to={`/?tag=${text.replace(' ', '-')}`} className={'tag-component'}>
                <StyledTag className={className}>
                    {text}
                </StyledTag>
            </Link>
        ) : (
            <span onClick={method} className={'tag-component'}>
                <StyledTag className={className}>
                    {text}
                </StyledTag>
            </span>
        )
    )
}

export default Tag
